const StaticCard = ({ position, digit }) => {
	return (
		<div className={position}>
			<span className="digit">{digit}</span>
		</div>
	);
};

export default StaticCard;
